module.exports = __webpack_public_path__ + "img/second_rects.9e16db70.svg";